import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { Layout, CheckEntry, StateInfoBox, AppImage } from "@/components";
import { PAGES, AmlStatusEnum } from "@/config";
import { useAmlHistoryStore, usePaymentStore } from "@/store";
import type { AmlHistoryItemData } from "@/store/models";

import emptyHistory from "@/assets/images/request-history-empty.png";

import styles from "./AmlHistory.module.sass";

const AmlHistory = () => {
  const navigate = useNavigate();

  const { history, fetchAmlHistory, historyLoading } = useAmlHistoryStore();
  const theInterval = useRef<any>(null);
  const clientSecret = usePaymentStore(
    (state) => state.paymentIntent?.clientSecret,
  );

  useEffect(() => {
    if (!history) {
      fetchAmlHistory();
    }
  }, [fetchAmlHistory, history]);

  useEffect(() => {
    const shouldRefetch =
      !!history &&
      history.items
        .slice(0, 15)
        .some((item) => item.status === AmlStatusEnum.PENDING);

    if (shouldRefetch) {
      theInterval.current = setInterval(() => {
        fetchAmlHistory();
      }, 15000);
    } else {
      clearInterval(theInterval.current);
      theInterval.current = null;
    }

    return () => {
      clearInterval(theInterval.current);
    };
  }, [fetchAmlHistory, history]);

  const hasItems = (history?.items?.length ?? 0) > 0;

  const onDetails = (item: AmlHistoryItemData) => {
    navigate(PAGES.AML_CHECK_DETAILS, { state: { itemId: item.uuid } });
  };

  return (
    <Layout
      title="Previous Checks"
      isShowBackButton={!!clientSecret}
      onBack={() => navigate(PAGES.HOME)}
    >
      <div className={styles.history}>
        {historyLoading && <StateInfoBox type="loading" />}
        {!historyLoading && (
          <>
            {!hasItems && (
              <div className={styles.empty}>
                <AppImage
                  src={emptyHistory}
                  alt=""
                  className={styles.emptyImage}
                />
                <div className={styles.emptyTitle}>Your history is empty</div>
              </div>
            )}
            {hasItems &&
              history?.items.map((item) => (
                <CheckEntry key={item.uuid} item={item} onDetails={onDetails} />
              ))}
          </>
        )}
      </div>
    </Layout>
  );
};

export default AmlHistory;
